export default __webpack_public_path__ + "static/media/1793.b49bcf55.png";